module.exports = "./assets/assets/资料交接.4e1fcbe0.docx";